import React from 'react'
import PropTypes from 'prop-types'
import { List, TextareaItem, Button, InputItem, NavBar, Checkbox, Icon, WhiteSpace, Picker, Toast, DatePicker,WingBlank,Steps } from 'antd-mobile'
import 'antd-mobile/dist/antd-mobile.css'
import { Link } from 'react-router-dom'
import { createForm } from 'rc-form'
import { postRequest } from '../../../utils/utils'
import './index.css'
import moment from 'moment'
import CustomerSearch from '../../components/customer_search'
const Item = List.Item;
const Step = Steps.Step;
const types = [
        {
            label: '内部考勤',
            value: 2,
        },
        {
            label: '外出考勤',
            value: 1,
        },
    ]

class XiaoJiaCheck extends React.Component {
  static propTypes = {
    form:PropTypes.object.isRequired,
      checkXiaoJia:PropTypes.func.isRequired
  }

  state = {
      xiaojia_id:'',
      data:{},
      option:'',
      status:'',
      out_time:'',//出门时间
      checkers:[],
      showbtn:true,
  };

  componentDidMount() {
    this.getDetail();
    this.getChecks();
  }
    getDetail = async() => {
        const xiaojia_id = localStorage.getItem('xiaojia_id');
        this.setState({xiaojia_id:xiaojia_id});
        postRequest(`/qingjiatiqian/checkview`, `id=${xiaojia_id}`).then((result) => {
            console.log(result)
            if(result && result.status === 1) {
                this.setState({data:result.data,status:result.data.status})
            } else {
                Toast.fail(result.msg || '获取失败', 1);
                if(result.msg === '请登陆！') {
                    localStorage.removeItem('daka_token')
                    alert('账号已在别处登录,请重新登录')
                    this.props.history.push('/')
                }
            }
        })
    }
    //获取主管
    getChecks = async() => {
        postRequest(`/yijiao/zhuguan`, ``).then((result) => {
            //console.log(result)
            if(result && result.status === 1) {
                this.setState({checkers:result.data})
            }
        })
    }
    //移交保存
    YiJiao = async(checkerid) => {
        const buka_id = localStorage.getItem('waichu_id');
        let body2=`id=${buka_id}&mokuai=out`;
        //获取移交前的数据
        postRequest(`/yijiao/yj`, body2).then((result) => {
            if(result && result.status === 1) {
                const shijian=result.data.shijian
                let body=`check_id=${checkerid}&id=${buka_id}&mokuai=out&shijian=${shijian}`;
                postRequest(`/yijiao/save`, body).then((result) => {
                    //console.log(result)
                    if(result && result.status === 1) {
                        Toast.success('移交成功',1);
                    }
                })
            }
        })
    }

    agree = (status) => {

        const {history, checkXiaoJia } = this.props
        let body =`id=${this.state.xiaojia_id}&status=${status}&content=${this.state.option}`
        if(status==2){
            if(this.state.option) {

            } else {
                Toast.info('审核不通过时，必须填写理由', 1);
                this.setState({showbtn:true})
                return
            }
        }
        //console.log(body);
        checkXiaoJia(body, history)
  }

    render() {
        const { data,checkers,showbtn } = this.state;
        const user = JSON.parse(localStorage.getItem('daka_user'))
        const u_id = user.u_id;
        //console.log(data);
        let checkername = [];
        checkername = checkers.map((value, index) => {
            return {
                value: value.u_id,
                label: value.u_fullname
            }
        });
        //console.log(data);
        return (
            <div style={{backgroundColor:'#f5f5f7', minHeight:document.documentElement.clientHeight }}>
                <NavBar
                    mode="dark"
                    icon={<Icon type="left" />}
                    onLeftClick={() => this.props.history.goBack() }
                >提前销假审核</NavBar>
                <List className="my-list detail_list" renderHeader=''>
                    <Item multipleLine wrap extra={data.user_id}>申请人</Item>
                    <Item multipleLine wrap extra={data.qj_start}>开始时间</Item>
                    <Item multipleLine wrap extra={data.qj_end}>结束时间</Item>
                    <Item multipleLine wrap extra={data.endtime}>提前销假时间</Item>
                    <Item multipleLine wrap extra={data.content}>提前销假原由</Item>
                </List>
                {((data.status==0&&data.check_id==u_id)||(data.status==3&&data.group_id==u_id))?
                <List renderHeader='审批意见'>
                        <TextareaItem
                            value={this.state.option}
                            onChange={value=>this.setState({option:value})}
                            placeholder="请填写审批意见"
                            data-seed="logId"
                            rows={4}
                            ref={el => this.customFocusInst = el}
                        />
                </List>:''}
                {data.record == '' ? '' :
                    <List renderHeader={() => '审核流程'} className="my-list">
                        <Steps className='check_step' size="small" current={5}>
                            {data.record == null ? '' :
                                data.record.map(i => (i.check_id == null ? '' :
                                        <Step key={i.id} status={i.status == 2 ? 'error' : 'process'}
                                              title=
                                                  {<div className='check_user'>
                                                      <span>{i.check_id}</span>
                                                      <span className='check_time'>{i.infotime}</span>
                                                  </div>}
                                              description={<div><span
                                                  className='check_status'>{i.status == 2 ? '审核未通过' : '审核通过'}</span>
                                                  {i.content == '' ? '' : <span>({i.content})</span>}</div>}
                                        />
                                ))
                            }
                        </Steps>
                    </List>
                }
                <div style={{height:'40px'}}></div>

                {(data.status==1||data.status==2)?'':
                    !showbtn?'':
                    data.check_name_id==u_id?
                <div className='bottom_btn'>
                    <div className='bottom_left' onClick={()=>{this.setState({showbtn:false});this.agree(2)}}>不同意</div>
                    <div className='bottom_right' onClick={()=>{this.setState({showbtn:false});this.agree(1)}}>同意</div>
                    {/*<Picker*/}
                        {/*data={checkername}*/}
                        {/*extra="移交主管"*/}
                        {/*value={this.state.checkerID}*/}
                        {/*cols={1}*/}
                        {/*onOk={(v)=>{this.YiJiao(v)}}*/}
                    {/*>*/}
                        {/*<div className='bottom_right'>移交</div>*/}
                    {/*</Picker>*/}
                </div>:''
                }
            </div>
        )
    }
}

export default createForm()(XiaoJiaCheck)